import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class Tare1 extends Component {
    constructor() {
        super();
        this.IsChecked = this.IsChecked.bind(this);
        this.Check = this.Check.bind(this);
        this.Save = this.Save.bind(this);
        this.ReLoad = this.ReLoad.bind(this);

        if (!Comm.ValidSession()) return;

        let sid = Context.GetContext().Sid;

        let articles = Comm.CallServerFunction("scales/get_tare_by_art_out", {
            session: sid
        });


        this.state = {
            Translation: Translation,
            Articles: articles.tare,
            Checked: new Set(),
            Tare: "0"
        };
    }

    IsChecked(id) {

        return this.state.Checked.has(id);
    }

    Check(id) {
        if (this.state.Checked.has(id)) {
            this.state.Checked.delete(id);
        }
        else {
            this.state.Checked.add(id)
        }
        const newSet = new Set([...this.state.Checked]);
        this.setState({ Checked: newSet });
    }

    Save() {
        let sid = Context.GetContext().Sid;
        let arr = Array.from(this.state.Checked);
        let articles = arr.map(x => {
            console.log("x", x);
            let val = x.replace("cbSel", "");
            return parseInt(val)
        });
        Comm.CallServerFunction("scales/save_tare_by_art_out", {
            session: sid,
            articles: `[${articles.join(',')}]`,
            tare: parseFloat(this.state.Tare)
        });
        this.ReLoad();
    }

    ReLoad() {
        let sid = Context.GetContext().Sid;

        let articles = Comm.CallServerFunction("scales/get_tare_by_art_out", {
            session: sid
        });


        this.setState
            ({
                Articles: articles.tare,
                Checked: new Set(),
                Tare: "0"
            });
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;
        let self = this;

        return (
            <div className="panel panel-default">
                <div className="panel-body">
                    <div className="row">
                        <div className="col-md-1"><input type="number" className="form-control" value={self.state.Tare} onChange={(e) => self.setState({ Tare: e.target.value })}></input></div>
                        <div className="col-md-3"><button className="btn btn-primary" onClick={() => self.Save()}>{Translation.Trans("save")}</button></div>


                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">{Translation.Trans("article")}</th>
                                        <th scope="col">{Translation.Trans("tare")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {self.state.Articles.map(x =>
                                        <tr key={x.id}>
                                            <th scope="row">
                                                <input type="checkbox" id={`cbSel${x.id}`} checked={self.IsChecked(`cbSel${x.id}`)} onClick={() => self.Check(`cbSel${x.id}`)} />
                                            </th>
                                            <td>
                                                {x.code}
                                            </td>
                                            <td>
                                                {x.tare}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div >
        );
    }
}

export default Tare1;



// WEBPACK FOOTER //
// ./src/pages/tare1.js